module.exports = __webpack_public_path__ + "img/2f_r_kasuya@2x.4d354d62.png";